<!-- 项目文件 -->
<template>
    <div>
        <Header1 :img="bgImg"></Header1>
        <div class="pt30 pb20 w1200 mauto">
            <div class="textc mt20 mb20 ">
                <p class="fs36 c999 disinblock posre">
                    <span class="border-bottom1">
                        联络方式
                    </span>
                </p>
            </div>
            <div class="w100p  mt40 mb20">
                    <div class=" vertop posre w22p disinblock ml18 mr18 box-shadow2 minh210 pt20  ">
                        <p class=" textc"><img class="w60 h60" src="../../public/img/img162.png"></p>      
                        <div class="posab w100p left0  top80  ">
                            <p class="pt20 fs216 c999 textc">公司名称</p>
                            <p class="  w70p lh22 pt20 fs14 c333 textc mauto ">
                                <span class="textc disinblock  w100p fs16 c333 disblock  ">江苏车里车外信息 技术有限公司</span>
                            </p>
                        </div>
                    </div>

                    <div class=" vertop posre w22p disinblock ml18 mr18 box-shadow2 minh210 pt20  ">
                        <p class=" textc"><img class="w50 h60" src="../../public/img/img163.png"></p>
                        <div class="posab w100p left0  top80  ">
                            <p class="pt20 fs216 c999 textc">地址</p>
                            <p class="  w70p lh22 pt20 fs14 c333 textc mauto ">
                                <span class="textc disinblock  w100p fs16 c333 disblock  ">江苏省南京市建邺区 广聚路33号11楼</span>
                            </p>
                        </div>
                    </div>
                    <div class=" vertop posre w22p disinblock ml18 mr18 box-shadow2 minh210 pt20">
                        <p class=" textc"><img class="w60 h45" src="../../public/img/img164.png"></p>
                        <div class="posab w100p left0  top80  ">
                            <p class="pt20 fs216 c999 textc">邮箱</p>
                            <p class="  w70p lh22 pt20 fs14 c333 textc mauto ">
                                <a class="textc disinblock  w100p fs16 c333 disblock" href="mailto:fuwu@yixueyijia.com">fuwu@yixueyijia.com</a>
                                <!-- <span class="textc disinblock  w100p fs16 c333 disblock  ">fuwu@yixueyijia.com</span> -->
                            </p>
                        </div>
                    </div>
                    <div class=" vertop posre w22p disinblock ml18 mr18 box-shadow2 minh210 pt20  ">
                    <p class=" textc"><img class="w65 h45" src="../../public/img/img161.png"></p>
                        <p class="pt20 fs216 c999 textc">联系电话</p>
                        <div class="  w70p lh22 pt20 fs14 c333 textc mauto">
                            <p class="textc disinblock  w100p fs16 c333 disblock  ">商务合作: 17751784850</p>
                            <p class="textc disinblock  w100p fs16 c333 disblock  ">合作加盟: 17788392294</p>
                            <P class="textc disinblock  w100p fs16 c333 disblock  ">客户服务: 17366393551</P>
                        </div>
                    </div>
        
            </div>
            <div class="w100p h400 mt40 mb20 overflow">
                <el-amap class="w48p disinblock floatl" :center='center' :zoom='zoom'>
                    <el-amap-marker :position="center" :label="label"></el-amap-marker>
                </el-amap>

                <div class="bgrg w48p floatr  alit disinblock pl10 pr10 overflow ">
                    <div class=" bgfff mauto pt20 pb20  pl10 pr10 border2e bradius8">
                        <div class="textc mt20 mb20 ">
                            <p class="fs36 c999 disinblock posre">
                                <span class="border-bottom1">
                                    联系我们
                                </span>
                            </p>
                        </div>
                        <div class="pt20 pb20 overflow">
                            <span class="disinblock bordercc h40 w48p floatl bradius8">
                                <input v-model="Name" class="textindent  bradius8 w100p h100p borderno outline" type="text"
                                    placeholder="姓名">
                            </span>
                            <span class="disinblock h40 bordercc w48p floatr bradius8">
                                <input v-model="Phone" class="textindent  bradius8 w100p h100p borderno outline" type="text"
                                    placeholder="手机号">
                            </span>
                            <span class="disinblock w9999 bordercc h100 mt20 bradius8">
                                <textarea rows="3" cols="20" v-model="Proposal"
                                    class="textindent  bradius8 w100p h100p borderno outline" placeholder="给我们提些建议吧～"></textarea>
                            </span>
                            <span @click="sentApply()" class="  w100p cursor cfff fs16 mt20 bg1f8 bradius2 disinblock textc h40 lh40">
                                确认提交
                            </span>
                        </div>
                    </div>
                </div>
            </div>

        </div>

            
        <Footer></Footer>
    </div>
</template>

<script>
    import Header1 from '@/components/Header1'
    import Footer from '@/components/Footer'
    import $ from "jquery";
    export default {
        data() {
            return {
                bgImg: require('../../public/img/img160.png'),
                Name: '',
                Phone: '',
                Proposal: '',
                center: [118.73373, 31.979144],
                zoom: 15,
                label: {
                    content: '江苏车里车外有限公司',
                    offset: [10, 12]
                }
            }
        },
        components: {
            Header1,
            Footer,
        },
        methods: {
            sentApply() {
                let that = this;
                if (that.Name == "" || !(/^1[23456789]\d{9}$/.test(that.Phone))) {
                    alert('请正确输入');
                    return 0;
                } else {
                    $.ajax({
                        type: "POST",
                        url: 'https://www.yixueyijia.com/product/zsjm.json',
                        dataType: "json",
                        async: false,
                        data: {
                            "name": that.Name,
                            "tel": that.Phone,
                            'email': 'clcw',
                            'city': '暂无'
                        },
                        success: function(data) {
                            if (data.code == 0) {
                                alert('提交成功')
                            } else {
                                alert('提交失败')
                            }
                        },
                        error: function(data) {
                            console.log(data);
                        }
                    });
                }

            }
        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bgrg {
        /* background: rgba(0, 0, 0, 0.5); */
    }
</style>